import { IItem } from '../store/timeline.types'

export const updateTimelineItemOnReorder = (timelineItem: IItem, selectedItem: IItem, isPTA: boolean): IItem => {
  const updatedTimelineItem: IItem = {
    ...timelineItem,
    date: selectedItem.date,
    labelHeader: selectedItem.labelHeader,
    subHeader: selectedItem.subHeader,
    labelHeaderFlag: isPTA ? 'PTA' : '',
  }

  return updatedTimelineItem
}
